import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Initialize with dummy client by default
const dummyClient = {
  auth: {
    getSession: async () => {
      throw new Error(
        "Supabase is not configured. Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your .env.local file.",
      );
    },
    onAuthStateChange: () => ({ data: { subscription: null } }),
    signInWithPassword: async () => {
      throw new Error(
        "Supabase is not configured. Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your .env.local file.",
      );
    },
    signOut: async () => {
      throw new Error(
        "Supabase is not configured. Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your .env.local file.",
      );
    },
    signUp: async () => {
      throw new Error(
        "Supabase is not configured. Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your .env.local file.",
      );
    },
    resetPasswordForEmail: async () => {
      throw new Error(
        "Supabase is not configured. Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your .env.local file.",
      );
    },
    updateUser: async () => {
      throw new Error(
        "Supabase is not configured. Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your .env.local file.",
      );
    },
    oauth: {
      getAuthorizationDetails: async () => {
        throw new Error(
          "Supabase is not configured. Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your .env.local file.",
        );
      },
      approveAuthorization: async () => {
        throw new Error(
          "Supabase is not configured. Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your .env.local file.",
        );
      },
      denyAuthorization: async () => {
        throw new Error(
          "Supabase is not configured. Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your .env.local file.",
        );
      },
    },
  },
};

export const supabase =
  supabaseUrl && supabaseAnonKey
    ? createClient(supabaseUrl, supabaseAnonKey)
    : dummyClient;
